const API_BASE = import.meta.env.VITE_API_BASE_URL || "/api";

export interface HealthResponse {
  status: string;
  service: string;
  version: string;
  timestamp: string;
}

export interface CapabilitiesResponse {
  service: string;
  version: string;
  transforms: string[];
  vocabularies: string[];
  fhir_profiles: string[];
  modes: string[];
  max_payload_sync_mb: number;
  max_payload_async_gb: number;
  edps_integration: {
    mode: string;
    default: string;
    opt_in: string;
  };
}

export interface MappingResponse {
  omop_records: Record<string, Array<Record<string, unknown>>>;
  mapping_metadata: {
    audit_id: string;
    timestamp: string;
    vocabularies_used: string[];
    unmapped_codes: string[];
    confidence_per_resource: Record<string, number>;
    profile_result: Record<string, unknown> | null;
  };
}

async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  }
  return res.json() as Promise<T>;
}

export const fhir2omopClient = {
  health: () => fetchJson<HealthResponse>("/healthz"),
  capabilities: () => fetchJson<CapabilitiesResponse>("/v1/capabilities"),
  wellKnown: () => fetchJson<Record<string, unknown>>("/.well-known/service.json"),
  mapBundle: (bundle: unknown, profile: "off" | "sync" = "off") =>
    fetchJson<MappingResponse>(`/v1/map/fhir2omop?profile=${profile}`, {
      method: "POST",
      body: JSON.stringify(bundle),
    }),
  validateBundle: (bundle: unknown) =>
    fetchJson<{ is_valid: boolean; profile: string | null; issues: string[] }>(
      "/v1/validate/fhir",
      { method: "POST", body: JSON.stringify(bundle) },
    ),
};
